// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderDots_loader__bX56M","l3":"LoaderDots_l3__ig2Lq"};